/**
 * 应用程序入口文件
 * 负责初始化Vue应用、配置路由并启动应用
 */

/**
 * 导入核心依赖模块
 */

// 导入Vue核心库
import Vue from 'vue'

// 导入Vue Router路由管理器
// 用于处理前端路由跳转和页面切换
import VueRouter from 'vue-router'

// 导入根组件App
// 应用程序的顶层组件，包含路由视图容器
import App from './App.vue'

/**
 * 导入页面组件
 */

// 首页组件
import Home from './views/Home.vue'

// 答题页面组件
// 用户回答问题的界面
import Quiz from './views/Quiz.vue'

// 抽奖转盘页面组件
// 展示抽奖转盘并处理抽奖逻辑的界面
import Lottery from './views/Lottery.vue'

// 抽奖成功页面组件
// 用户抽奖成功后的提示页面
import Success from './views/Success.vue'

// 抽奖失败页面组件
// 用户抽奖失败或未中奖时的提示页面
import Failure from './views/Failure.vue'

// 奖品展示页面组件
// 展示用户获得的奖品并收集领奖信息
import prize from './views/prize.vue'

// 抽奖记录页面组件
// 展示用户的抽奖历史记录
import Records from './views/Records.vue'

/**
 * 注册Vue插件
 */

// 全局注册Vue Router插件
// 使Vue实例能够使用路由功能
Vue.use(VueRouter)

/**
 * 路由配置
 * 定义应用程序的所有路由路径和对应的组件
 */
const routes = [
  {
    path: '/', // 根路径
    name: 'Home', // 路由名称，用于编程式导航
    component: Home // 对应的页面组件
  },
  {
    path: '/quiz', // 答题页面路径
    name: 'Quiz',
    component: Quiz
  },
  {
    path: '/lottery', // 抽奖转盘页面路径
    name: 'Lottery',
    component: Lottery
  },
  {
    path: '/success', // 成功页面路径
    name: 'Success',
    component: Success
  },
  {
    path: '/failure', // 失败页面路径
    name: 'Failure',
    component: Failure
  },
  {
    path: '/prize', // 奖品页面路径
    name: 'prize',
    component: prize
  },
  {
    path: '/records', // 抽奖记录页面路径
    name: 'Records',
    component: Records
  }
]

/**
 * 创建路由实例
 */
const router = new VueRouter({
  routes, // 路由配置数组
  // 使用hash模式的路由
  // 优势：在微信等第三方环境中兼容性更好，不会触发页面刷新
  // 格式为：http://domain/#/path
  mode: 'hash'
})

/**
 * 创建并挂载Vue应用实例
 */
new Vue({
  router, // 注入路由实例到Vue实例中
  // 渲染函数 - 使用h函数创建App组件的虚拟DOM
  // 替代传统的template选项，提高渲染性能
  render: h => h(App) 
  // 挂载到HTML文档中的#app元素
  // 将渲染后的组件插入到DOM中
}).$mount('#app')